import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=239d915b&scoped=true"
import script from "./Post.vue?vue&type=script&lang=js"
export * from "./Post.vue?vue&type=script&lang=js"
import style0 from "./Post.vue?vue&type=style&index=0&id=239d915b&prod&scoped=true&lang=css"
import style1 from "./Post.vue?vue&type=style&index=1&id=239d915b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d915b",
  null
  
)

export default component.exports